import { render } from "./SkychartObjectsTable.vue?vue&type=template&id=4b3c723a"
import script from "./SkychartObjectsTable.vue?vue&type=script&lang=js"
export * from "./SkychartObjectsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__